import { Artwork } from '../types';

export const artworks: Artwork[] = [
  {
    id: 'artwork-1',
    title: 'Atome',
    description: '',
    category: 'abstract',
    tags: ['traditional', 'ink'],
    imageUrl: '/img/IMG_20251108_124748.jpg',
    date: '2015-05',
    featured: true,
  },
  {
    id: 'artwork-2',
    title: 'Brain Network',
    description: '',
    category: 'abstract',
    tags: ['traditional', 'ink'],
    imageUrl: '/img/IMG_20260327_081654.jpg',
    date: '2023-30',
    featured: true,
  },
  {
    id: 'artwork-3',
    title: 'Dark prison',
    description: '',
    category: 'abstract',
    tags: ['traditional', 'ink'],
    imageUrl: '/img/IMG_20260327_081744.jpg',
    date: '2023-11',
    featured: true,
  },
  {
    id: 'artwork-4',
    title: 'The point',
    description: '',
    category: 'abstract',
    tags: ['traditional', 'ink'],
    imageUrl: '/img/IMG_20260304_110020.jpg',
    date: '2023-11',
    featured: true,
  },
  {
    id: 'artwork-5',
    title: 'Liqueur',
    description: '',
    category: 'abstract',
    tags: ['traditional', 'ink'],
    imageUrl: '/img/IMG_20260327_081843.jpg',
    date: '2025-10',
  },
  {
    id: 'artwork-6',
    title: 'The passage of time',
    description: '',
    category: 'abstract',
    tags: ['traditional', 'ink'],
    imageUrl: '/img/IMG_20260414_161330.jpg',
    date: '2026-03',
    featured: true,
  },
  {
    id: 'artwork-7',
    title: 'The passage of time',
    description: '',
    category: 'abstract',
    tags: ['traditional', 'ink'],
    imageUrl: '/img/IMG_20260327_082016.jpg',
    date: '2026-03'
  },
  {
    id: 'artwork-8',
    title: 'Ciel',
    description: '',
    category: 'pixelArt',
    tags: ['digital', 'fantasy'],
    imageUrl: '/img/Sky_02(x1000).gif',
    date: '2022-09',
  },
  {
    id: 'artwork-9',
    title: 'Danette à la fraise',
    description: '',
    category: 'pixelArt',
    tags: ['digital', 'fantasy'],
    imageUrl: '/img/Danette à la fraise new.png',
    date: '2026-07',
  }
];

export const getFeaturedArtworks = () => artworks.filter((a) => a.featured);

export const getArtworksByCategory = (category: Artwork['category']) =>
  artworks.filter((a) => a.category === category);

export const artCategories: { key: Artwork['category']; labelKey: string }[] = [
  { key: 'abstract', labelKey: 'art.gallery.filters.abstract' },
  { key: 'illustration', labelKey: 'art.gallery.filters.illustration' },
  { key: 'pixelArt', labelKey: 'art.gallery.filters.pixelArt' },
  { key: 'concept-art', labelKey: 'art.gallery.filters.conceptArt' },
  { key: 'fan-art', labelKey: 'art.gallery.filters.fanArt' },
];
